export default {
  api: {
    protocol: 'https',
    baseUri: 'api.tracker.hivgov.icfcloud.com',
  },
  analytics: {
    trackingId: 'UA-192679391-1',
  },
  cognito: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_bvSUQQQOa',
    userPoolWebClientId: '158lm81cntpd3h2vepn6h3dj58',
  },
  app: {
    idleTimer: 15 * 60,
    sessionTimeout: 60 * 60 * 8,
  },
  env: {
    hostname: ['localhost', 'dev.tracker.hivgov.icfcloud.com'],
  },
  webpush: {
    vapidKeyPublic: 'BK543r20HQfOqXVzncY8HG8MCak-i8r6t2BgesowWgMTIsknaB50V8lZk_lz8lUNgYc0Qi3JHVLW3w6zkhLhPBo',
  },
};
